// import React, { useState, useRef, useEffect } from 'react';
// import DatePicker from 'react-datepicker';
// import "react-datepicker/dist/react-datepicker.css";
// import './DateTimePicker.css';

// const DateTimeInputField = ({
//   label,
//   defaultValue = null,
//   onChange,
//   name,
//   disablePastDates,
//   disableFutureDates,
//   startDate,
//   important = false,
//   readOnly = false,
//   showTimeSelect = false,
//   timeFormat = "HH:mm",
//   timeIntervals = 15,
//   dateFormat = "yyyy-MM-dd"
// }) => {
//   const [selectedDate, setSelectedDate] = useState(defaultValue);
//   const [isFocused, setIsFocused] = useState(false);
//   const datePickerRef = useRef(null);

//   useEffect(() => {
//     setSelectedDate(defaultValue);
//   }, [defaultValue]);

//   const handleDateChange = (date) => {
//     setSelectedDate(date);

//     if (onChange) {
//       const syntheticEvent = {
//         target: {
//           name: name,
//           value: date ? date.toISOString() : null
//         }
//       };
//       onChange(syntheticEvent);
//     }
//   };

//   const handleCalendarIconClick = () => {
//     if (datePickerRef.current) {
//       datePickerRef.current.setFocus();
//     }
//   };

//   const getMinDate = () => {
//     if (startDate) {
//       return new Date(startDate);
//     } else if (disablePastDates) {
//       return new Date();
//     }
//     return undefined;
//   };

//   const getMaxDate = () => {
//     if (disableFutureDates) {
//       return new Date();
//     }
//     return undefined;
//   };

//   const hasValue = selectedDate !== null && selectedDate !== undefined;
//   const shouldShowLabel = hasValue || isFocused;

//   const displayFormat = showTimeSelect
//     ? "yyyy-MM-dd HH:mm"
//     : dateFormat;

//   return (
//     <div className='datetime-picker-container'>
//       <div className="datetime-picker-wrapper">
//         <DatePicker
//           ref={datePickerRef}
//           selected={selectedDate}
//           onChange={handleDateChange}
//           onFocus={() => setIsFocused(true)}
//           onBlur={() => setIsFocused(false)}
//           className="datetime-picker-input"
//           name={name}
//           readOnly={readOnly}
//           minDate={getMinDate()}
//           maxDate={getMaxDate()}
//           showTimeSelect={showTimeSelect}
//           timeFormat={timeFormat}
//           timeIntervals={timeIntervals}
//           dateFormat={displayFormat}
//           placeholderText=""
//           autoComplete="off"
//         />

//         <label className={`datetime-picker-label ${
//           shouldShowLabel ? 'has-value' : ''
//         }`}>
//           {label}
//           {important && <span className="required-asterisk">*</span>}
//         </label>

//         <div className='datetime-calendar-icon' onClick={handleCalendarIconClick}>
//           <svg className='datetime-calendar-svg' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//             <path opacity="0.5" d="M20 8H0V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V8ZM5 6C4.73478 6 4.48043 5.89464 4.29289 5.70711C4.10536 5.51957 4 5.26522 4 5V1C4 0.734784 4.10536 0.48043 4.29289 0.292893C4.48043 0.105357 4.73478 0 5 0C5.26522 0 5.51957 0.105357 5.70711 0.292893C5.89464 0.48043 6 0.734784 6 1V5C6 5.26522 5.89464 5.51957 5.70711 5.70711C5.51957 5.89464 5.26522 6 5 6ZM15 6C14.7348 6 14.4804 5.89464 14.2929 5.70711C14.1054 5.51957 14 5.26522 14 5V1C14 0.734784 14.1054 0.48043 14.2929 0.292893C14.4804 0.105357 14.7348 0 15 0C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V5C16 5.26522 15.8946 5.51957 15.7071 5.70711C15.5196 5.89464 15.2652 6 15 6Z" fill="#6D6D6D"/>
//             <path d="M17 2H16V5C16 5.26522 15.8946 5.51957 15.7071 5.70711C15.5196 5.89464 15.2652 6 15 6C14.7348 6 14.4804 5.89464 14.2929 5.70711C14.1054 5.51957 14 5.26522 14 5V2H6V5C6 5.26522 5.89464 5.51957 5.70711 5.70711C5.51957 5.89464 5.26522 6 5 6C4.73478 6 4.48043 5.89464 4.29289 5.70711C4.10536 5.51957 4 5.26522 4 5V2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.316071 3.44129 0 4.20435 0 5V8H20V5C20 4.20435 19.6839 3.44129 19.1213 2.87868C18.5587 2.31607 17.7956 2 17 2Z" fill="#454545"/>
//           </svg>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DateTimeInputField;

import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DateTimePicker.css";
import { useTranslation } from "react-i18next";
import useAppConfigStore from "../../../store/useAppConfigStore";
import useFinancialYearLockStore from "../../../store/useFinancialYearLockStore";

// ============================================================================
// HELPER: Convert app config format to react-datepicker format string
// App config uses: "DD MM YYYY", "YYYY MM DD", "MM DD YYYY"
// react-datepicker uses: "dd", "MM", "yyyy" with literal separator
// ============================================================================
const getPickerFormat = (dateFormat, dateSeparator, showTimeSelect) => {
  const sep = dateSeparator || "-";
  let format = "";

  switch (dateFormat) {
    case "YYYY MM DD":
      format = `yyyy${sep}MM${sep}dd`;
      break;
    case "MM DD YYYY":
      format = `MM${sep}dd${sep}yyyy`;
      break;
    case "DD MM YYYY":
    default:
      format = `dd${sep}MM${sep}yyyy`;
      break;
  }

  if (showTimeSelect) {
    format += " HH:mm";
  }

  return format;
};

// ============================================================================
// HELPER: Smart parse a date string in any common format
// Supports: YYYY-MM-DD, DD-MM-YYYY, MM-DD-YYYY, and / variants
// ============================================================================
const smartParseDate = (dateStr) => {
  if (!dateStr || dateStr instanceof Date)
    return dateStr instanceof Date ? dateStr : null;

  // Try native parse first (handles ISO "YYYY-MM-DD" and "YYYY-MM-DD HH:mm")
  const native = new Date(dateStr);
  if (!isNaN(native.getTime())) return native;

  // Normalize separators to "-"
  const normalized = dateStr.replace(/\//g, "-").trim();
  const parts = normalized.split(/[-\s]/);

  if (parts.length >= 3) {
    const [a, b, c] = parts;

    // If first part is 4 digits → YYYY-MM-DD
    if (a.length === 4) {
      const d = new Date(parseInt(a), parseInt(b) - 1, parseInt(c));
      if (!isNaN(d.getTime())) return d;
    }

    // If last part is 4 digits → could be DD-MM-YYYY or MM-DD-YYYY
    if (c.length === 4) {
      // Try DD-MM-YYYY first (day ≤ 31, month ≤ 12)
      const dayFirst = new Date(parseInt(c), parseInt(b) - 1, parseInt(a));
      if (
        !isNaN(dayFirst.getTime()) &&
        parseInt(b) <= 12 &&
        parseInt(a) <= 31
      ) {
        return dayFirst;
      }
      // Try MM-DD-YYYY
      const monthFirst = new Date(parseInt(c), parseInt(a) - 1, parseInt(b));
      if (
        !isNaN(monthFirst.getTime()) &&
        parseInt(a) <= 12 &&
        parseInt(b) <= 31
      ) {
        return monthFirst;
      }
    }
  }

  return null;
};

const DateTimeInputField = ({
  label,
  defaultValue = null,
  onChange,
  name,
  disablePastDates,
  disableFutureDates,
  startDate,
  important = false,
  readOnly = false,
  error,
  showTimeSelect = false,
  timeFormat = "HH:mm",
  timeIntervals = 15,
  className = "",
  border = " ",
  portalId,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const datePickerRef = useRef(null);
  const { t } = useTranslation();

  // Read date config from store
  const dateFormat = useAppConfigStore((state) => state.dateFormat);
  const dateSeparator = useAppConfigStore((state) => state.dateSeparator);

  // Read locked financial year intervals directly from global store
  const fyLockedIntervals = useFinancialYearLockStore((state) => state.lockedIntervals);
  const isFyLoaded = useFinancialYearLockStore((state) => state.isLoaded);
  const fetchLockedFinancialYears = useFinancialYearLockStore((state) => state.fetchLockedFinancialYears);

  useEffect(() => {
    if (!isFyLoaded) {
      fetchLockedFinancialYears();
    }
  }, [isFyLoaded, fetchLockedFinancialYears]);

  // Convert defaultValue into a Date object using smart parser
  useEffect(() => {
    if (defaultValue) {
      if (defaultValue instanceof Date) {
        setSelectedDate(defaultValue);
      } else if (typeof defaultValue === "string") {
        const parsed = smartParseDate(defaultValue);
        setSelectedDate(parsed);
      }
    } else {
      setSelectedDate(null);
    }
  }, [defaultValue]);

  const formatForBackend = (date) => {
    if (!date) return null;

    if (showTimeSelect) {
      // Always send UTC ISO string so the backend stores the correct time
      return date.toISOString();
    }

    const pad = (n) => String(n).padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);

    if (onChange) {
      const syntheticEvent = {
        target: {
          name: name,
          value: date ? formatForBackend(date) : null,
        },
      };
      onChange(syntheticEvent);
    }
  };

  const handleCalendarIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };

  const getMinDate = () => {
    if (startDate) {
      const parsed = smartParseDate(startDate);
      return parsed || new Date(startDate);
    } else if (disablePastDates) {
      return new Date();
    }
    return undefined;
  };

  const getMaxDate = () => {
    if (disableFutureDates) {
      return new Date();
    }
    return undefined;
  };

  const hasValue = selectedDate !== null && selectedDate !== undefined;
  const shouldShowLabel = hasValue || isFocused;

  // Build display format from app config
  // Use 12-hour format with AM/PM when time is shown (matches how backend datetimes are displayed)
  const displayFormat = showTimeSelect
    ? getPickerFormat(dateFormat, dateSeparator, false) + " h:mm aa"
    : getPickerFormat(dateFormat, dateSeparator, false);

  const handleKeyDown = (e) => {
    if (
      e.ctrlKey ||
      e.metaKey ||
      [
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "Escape",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ].includes(e.key)
    ) {
      return;
    }

    if (/^[a-zA-Z]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleChangeRaw = (e) => {
    if (e && e.target && typeof e.target.value === "string") {
      if (/[a-zA-Z]/.test(e.target.value)) {
        e.target.value = e.target.value.replace(/[a-zA-Z]/g, "");
      }
    }
  };

  return (
    <div className={`${className} datetime-picker-container`}>
      <div className="datetime-picker-wrapper">
        <DatePicker
          ref={datePickerRef}
          selected={selectedDate}
          onChange={handleDateChange}
          onKeyDown={handleKeyDown}
          onChangeRaw={handleChangeRaw}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={`datetime-picker-input ${error ? "input-error" : ""} ${border}`}
          name={name}
          readOnly={readOnly}
          minDate={getMinDate()}
          maxDate={getMaxDate()}
          excludeDateIntervals={fyLockedIntervals}
          showTimeSelect={showTimeSelect}
          timeFormat={showTimeSelect ? "h:mm aa" : timeFormat}
          timeIntervals={timeIntervals}
          dateFormat={displayFormat}
          placeholderText=""
          autoComplete="off"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          portalId={portalId}
        />

        <label
          className={`datetime-picker-label ${
            shouldShowLabel ? "has-value" : ""
          }`}
        >
          {t(label)}
          {important && <span className="required-asterisk">*</span>}
        </label>

        <div
          className="datetime-calendar-icon"
          onClick={handleCalendarIconClick}
          data-tooltip-id="global-tooltip"
          data-tooltip-content={t("Select Date")}
        >
          <svg
            className="datetime-calendar-svg"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              opacity="0.5"
              d="M20 8H0V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V8ZM5 6C4.73478 6 4.48043 5.89464 4.29289 5.70711C4.10536 5.51957 4 5.26522 4 5V1C4 0.734784 4.10536 0.48043 4.29289 0.292893C4.48043 0.105357 4.73478 0 5 0C5.26522 0 5.51957 0.105357 5.70711 0.292893C5.89464 0.48043 6 0.734784 6 1V5C6 5.26522 5.89464 5.51957 5.70711 5.70711C5.51957 5.89464 5.26522 6 5 6ZM15 6C14.7348 6 14.4804 5.89464 14.2929 5.70711C14.1054 5.51957 14 5.26522 14 5V1C14 0.734784 14.1054 0.48043 14.2929 0.292893C14.4804 0.105357 14.7348 0 15 0C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V5C16 5.26522 15.8946 5.51957 15.7071 5.70711C15.5196 5.89464 15.2652 6 15 6Z"
              fill="#6D6D6D"
            />
            <path
              d="M17 2H16V5C16 5.26522 15.8946 5.51957 15.7071 5.70711C15.5196 5.89464 15.2652 6 15 6C14.7348 6 14.4804 5.89464 14.2929 5.70711C14.1054 5.51957 14 5.26522 14 5V2H6V5C6 5.26522 5.89464 5.51957 5.70711 5.70711C5.51957 5.89464 5.26522 6 5 6C4.73478 6 4.48043 5.89464 4.29289 5.70711C4.10536 5.51957 4 5.26522 4 5V2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.316071 3.44129 0 4.20435 0 5V8H20V5C20 4.20435 19.6839 3.44129 19.1213 2.87868C18.5587 2.31607 17.7956 2 17 2Z"
              fill="#454545"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default DateTimeInputField;
